// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2358cc6c","667":"2ef1fc9e","977":"7313f248"}[chunkId] + ".chunk.js";
};